export const LEVEL_QUANTITY = 4
export const BOARD_SIZE = 49

export const STEP_BRIEF = 0
export const STEP_GAME = 1
export const STEP_RESULT = 2

export const LEVEL_START = 0

export const LEVEL_BLACK_INC = 1
export const LEVEL_RED_DEC = 2
export const LEVEL_MIXED = 3

export const LEVEL_BLACK_INC_LAST = 23
export const LEVEL_RED_DEC_LAST = 24
export const LEVEL_MIXED_LAST = BOARD_SIZE - 1



// WEBPACK FOOTER //
// ./src/consts.js